<template>
    <div>
      <v-data-table
        v-if="tableData.length"
        :headers="headers"
        :items="tableData"
        :items-per-page="gWorkflowTableSize"
        :page="gWorkflowTablePage"
        item-key="id"
        sort-by="name"
        :header-props="{ sortIcon: null }"
        :server-items-length="gWorkflowResponseTotalElements"
        :footer-props="{
          'items-per-page-options': [10, 25, 50, 100],
        }"
        @update:items-per-page="updatePageSize"
        @update:page="updatePageNumber"
        @click:row="$emit('call-edit-form', $event)"
      >
        <template v-slot:[`item.name`]="{ item }">
          <span class="text-truncate">{{ item.name }}</span>
        </template>

        <template v-slot:[`item.primary`]="{ item }">
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-chip 
                v-bind="attrs"
                v-on="on">
                {{ item.primary.length }}
              </v-chip>
            </template>
            <div class="tooltip-container">
              <div class="tooltip-top">
                <div class="tooltip-top-left">P1</div>
                <div class="tooltip-top-right">
                  <span class="custom-tooltip" v-for="(el, index) in item.primary.filter(el => el.writerTier === 'P1')" :key="index">{{ el.name }}</span>
                </div>
              </div>
              <div class="tooltip-bottom">
                <div class="tooltip-bottom-left">P2</div>
                <div class="tooltip-bottom-right">
                  <span class="custom-tooltip" v-for="(el, index) in item.primary.filter(el => el.writerTier === 'P2')" :key="index">{{ el.name }}</span>
                </div>
              </div>
            </div>
          </v-tooltip>
        </template>

        <template v-slot:[`item.secondary`]="{ item }">
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-chip 
                v-bind="attrs"
                v-on="on">
                {{ item.secondary.length }}
              </v-chip>
            </template>
            <div class="tooltip-container">
              <div class="tooltip-top">
                <div class="tooltip-top-left">S1</div>
                <div class="tooltip-top-right">
                  <span class="custom-tooltip" v-for="(el, index) in item.secondary.filter(el => el.editorTier === 'S1')" :key="index">{{ el.name }}</span>
                </div>
              </div>
              <div class="tooltip-bottom">
                <div class="tooltip-bottom-left">S2</div>
                <div class="tooltip-bottom-right">
                  <span class="custom-tooltip" v-for="(el, index) in item.secondary.filter(el => el.editorTier === 'S2')" :key="index">{{ el.name }}</span>
                </div>
              </div>
            </div>
          </v-tooltip>
        </template>

        <template v-slot:[`item.qc`]="{ item }">
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-chip 
                v-bind="attrs"
                v-on="on">
                {{ item.qc.length }}
              </v-chip>
            </template>
            <div class="tooltip-container">
              <div class="tooltip-top">
                <div class="tooltip-top-left">Q1</div>
                <div class="tooltip-top-right">
                  <span class="custom-tooltip" v-for="(el, index) in item.qc.filter(el => el.qcTier === 'Q1')" :key="index">{{ el.name }}</span>
                </div>
              </div>
              <div class="tooltip-bottom">
                <div class="tooltip-bottom-left">Q2</div>
                <div class="tooltip-bottom-right">
                  <span class="custom-tooltip" v-for="(el, index) in item.qc.filter(el => el.qcTier === 'Q2')" :key="index">{{ el.name }}</span>
                </div>
              </div>
            </div>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-skeleton-loader
        v-if="!tableData.length"
        type="table"
        height="40vh"
      ></v-skeleton-loader>
    </div>
  </template>
  
  <script>
  // libraries
  import _ from "lodash";
  import { mapGetters, mapActions } from "vuex";
  // internal
  import { customBreakpoint, timeUnits } from "@/utils/mixins";
  import { getWorkflofsByProject } from "@/utils/newDbUtils";
  
  export default {
    name: "WorkflowExpandedTable",
    props: {
      projectData: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        headers: [
            { text: "Project", value: "project" },
            { text: "Workflow Name", value: "workflowName" },
            { text: "GEO", value: "geo" },
            { text: "Primary", value: "primary" },
            { text: "Secondary", value: "secondary" },
            { text: "QC", value: "qc" },
        ],
        tableData: [],
      };
    },
    mixins: [customBreakpoint, timeUnits],
    watch: {
      gWorkflowTablePage: {
        async handler() {
          const query ={
            page: this.gWorkflowTablePage - 1,
            size: this.gWorkflowTableSize,
            projectId: this.projectData.id,
            ...this.$route.query
          }
          await this.aGetWorkflowsList({query});
          this.tableData = this.gWorkflowData;
        },
      },
      gWorkflowTableSize: {
        async handler() {
          const query ={
            page: this.gWorkflowTablePage - 1,
            size: this.gWorkflowTableSize,
            projectId: this.projectData.id,
            ...this.$route.query
          }
          await this.aGetWorkflowsList({query});
          this.tableData = this.gWorkflowData;
        },
      }
    },
    computed: {
      ...mapGetters("workflow", [
        "gWorkflowResponseTotalElements",
        "gWorkflowTablePage",
        "gWorkflowTableSize",
        "gWorkflowData"
      ]),
    },
    methods: {
      ...mapActions("workflow", [
        "aGetWorkflowsList",
        "aSetWorkflowTablePage",
        "aSetWorkflowTableSize"
      ]),
      updatePageSize(size) {
            this.aSetWorkflowTableSize(size);
        },
        updatePageNumber(page) {
            this.aSetWorkflowTablePage(page);
        }
    },
    async mounted() {
      const query = {
        projectId: this.projectData.id,
        page: this.gWorkflowTablePage - 1,
        size: this.gWorkflowTableSize,
        ...this.$route.query
      }
      await this.aGetWorkflowsList({query});
      this.tableData = this.gWorkflowData;
    }
  };
  </script>
  
  <style scoped lang="scss">
  .group-header-row {
    background-color: #9af9ef70 !important;
    color: #003a35 !important;
  }
  .vertical-middle {
    vertical-align: middle;
  }
  
  ::v-deep {
    tbody > tr {
      cursor: pointer;
    }
    .v-data-table.laptop .v-data-table__wrapper table {
      & tbody > tr > td {
        padding: 0 8px;
      }
      & .v-data-table-header tr > th {
        padding: 0 8px;
      }
    }
    .v-data-table.laptopSmaller .v-data-table__wrapper table {
      & tbody > tr > td {
        padding: 0 4px;
      }
      & .v-data-table-header tr > th {
        padding: 0 4px;
      }
    }
  }

  .custom-tooltip {
    display: block;
  }

  .tooltip-container {
    display: flex;
    flex-direction: column;
    background: transparent;
    & .tooltip {
      &-top {
        display: flex;
        border-bottom: 1px solid #9af9ef;
        &-left {
          width: 25px;
          border-right: 1px solid #9af9ef;
          padding-right: 5px;
          display: flex;
        }
        &-right {
          padding-left: 7px;
        }
      }
      &-bottom {
        display: flex;
        &-left {
          width: 25px;
          border-right: 1px solid #9af9ef;
          padding-right: 5px;
          display: flex;
        }
        &-right {
          padding-left: 7px;
        }
      }
    }
  }
  </style>  